import history from '../history'
import {
  login,
  getUserAttributes,
  passwordReset,
  passwordResetWithCode,
  sendCode,
  authUser,
  signOutUser
} from '../library/aws'

const initialState = {
  authenticated: false,
  username: '',
  accountId: '',
  contactId: '',
  aberdeenImpersonator: false,
  accountName: '',
  contactName: '',
  contactEmail: '',
  postOpsAMName: null,
  postOpsAMEmail: null,
  liveOpsAMName: null,
  liveOpsAMEmail: null,
  salesEngineerName: null,
  salesEngineerEmail: null,
  user: {},
  login: {
    loading: false,
    password: '',
    success: false,
    error: '',
    hasError: false
  },
  passwordReset: {
    show: false,
    loading: false,
    success: false,
    error: '',
    hasError: false,
    newPassword: '',
    repeatPassword: '',
    verificationCode: '',
    resetWithCode: false
  },
  verificationCode: {
    show: false,
    loading: false,
    email: '',
    success: false,
    error: '',
    hasError: false
  }
}

const UPDATE_LOGIN = 'auth/UPDATE_LOGIN'
const UPDATE_RESET = 'auth/UPDATE_RESET'
const UPDATE_VERIFICATION_CODE = 'auth/UPDATE_VERIFICATION_CODE'
const UPDATE_AUTHENTICATED = 'auth/UPDATE_AUTHENTICATED'
const UPDATE_USER = 'auth/UPDATE_USER'
const UPDATE_USERNAME = 'auth/UPDATE_USERNAME'
const UPDATE_CONTACT_ID = 'auth/UPDATE_CONTACT_ID'
const UPDATE_ACCOUNT_ID = 'auth/UPDATE_ACCOUNT_ID'
const UPDATE_ABERDEEN_IMPERSONATOR = 'auth/UPDATE_ABERDEEN_IMPERSONATOR'

export const UPDATE_USER_ATTRIBUTES = 'auth/UPDATE_USER_ATTRIBUTES'

const handler = (state = initialState, action) => {
  const {payload} = action

  switch (action.type) {
    case UPDATE_AUTHENTICATED:
      return {
        ...state,
        authenticated: payload
      }

    case UPDATE_USER:
      return {
        ...state,
        user: payload
      }

    case UPDATE_USERNAME:
      return {
        ...state,
        username: payload
      }

    case UPDATE_LOGIN:
      return {
        ...state,
        login: {
          ...state.login,
          ...payload
        }
      }

    case UPDATE_RESET:
      return {
        ...state,
        passwordReset: {
          ...state.passwordReset,
          ...payload
        }
      }

    case UPDATE_VERIFICATION_CODE:
      return {
        ...state,
        verificationCode: {
          ...state.verificationCode,
          ...payload
        }
      }

    case UPDATE_ACCOUNT_ID:
      return {
        ...state,
        accountId: payload
      }

    case UPDATE_CONTACT_ID:
      return {
        ...state,
        contactId: payload
      }

    case UPDATE_ABERDEEN_IMPERSONATOR:
      return {
        ...state,
        aberdeenImpersonator: payload
      }

    case UPDATE_USER_ATTRIBUTES:
      return {
        ...state,
        ...payload
      }

    default:
      return state
  }
}

export const authenticateUser = () => {
  return async(dispatch, getState) => {
    try {
      const {
        user,
        authenticated
      } = await authUser()

      dispatch({
        type: UPDATE_USER,
        payload: user
      })

      dispatch({
        type: UPDATE_AUTHENTICATED,
        payload: authenticated
      })

      const {
        'custom:PrimaryAccountSfid' :accountId,
        'custom:ContactSfid' :contactId,
        'custom:AberdeenImpersonator': aberdeenImpersonator
      } = await getUserAttributes(user)

      dispatch({
        type: UPDATE_ACCOUNT_ID,
        payload: accountId
      })

      dispatch({
        type: UPDATE_CONTACT_ID,
        payload: contactId
      })

      if(aberdeenImpersonator === 'true') {
        dispatch({
          type: UPDATE_ABERDEEN_IMPERSONATOR,
          payload: true
        })
      }

      if(aberdeenImpersonator === 'false') {
        dispatch({
          type: UPDATE_ABERDEEN_IMPERSONATOR,
          payload: false
        })
      }

      if (history.location.pathname === '/login') {
        history.push('/')
      }
    }
    catch (e) {
      history.push('/login')
    }
  }
}

export const requestLogin = () => {
  return async(dispatch, getState) => {
    dispatch({
      type: UPDATE_LOGIN,
      payload: {
        loading: true,
        hasError: false,
        error: ''
      }
    })

    dispatch({
      type: UPDATE_RESET,
      payload: {
        loading: false,
        hasError: false,
        success: false,
        error: ''
      }
    })

    dispatch({
      type: UPDATE_VERIFICATION_CODE,
      payload: {
        loading: false,
        hasError: false,
        success: false,
        error: ''
      }
    })

    try {
      const {
        username
      } = getState().stores.auth

      const {
        password
      } = getState().stores.auth.login

      const loginAttempt = await login(username, password)

      const {
        authenticated,
        newPasswordRequired,
        user
      } = loginAttempt

      if(authenticated) {
        const {
          'custom:PrimaryAccountSfid' :accountId,
          'custom:ContactSfid' :contactId
        } = await getUserAttributes(user)

        dispatch({
          type: UPDATE_ACCOUNT_ID,
          payload: accountId
        })

        dispatch({
          type: UPDATE_CONTACT_ID,
          payload: contactId
        })
      }

      dispatch({
        type: UPDATE_AUTHENTICATED,
        payload: authenticated
      })

      dispatch({
        type: UPDATE_RESET,
        payload: {
          show: newPasswordRequired
        }
      })

      if(user) {
        dispatch({
          type: UPDATE_USER,
          payload: user
        })
      }

      if(authenticated) {
        history.push('/')
      }
    }
    catch (e) {
      dispatch({
        type: UPDATE_LOGIN,
        payload: {
          hasError: true,
          error: e.message
        }
      })
    }

    dispatch({
      type: UPDATE_LOGIN,
      payload: {
        loading: false
      }
    })
  }
}

export const reportUsername = username => {
  return async dispatch => {
    dispatch({
      type: UPDATE_USERNAME,
      payload: username
    })
  }
}

export const reportPassword = password => {
  return async dispatch => {
    try {
      dispatch({
        type: UPDATE_LOGIN,
        payload: {
          password
        }
      })
    }
    catch (e) {
      dispatch({
        type: UPDATE_LOGIN,
        payload: {
          hasError: true,
          error: e.message
        }
      })
    }
  }
}

export const reportNewPassword = newPassword => {
  return async dispatch => {
    try {
      dispatch({
        type: UPDATE_RESET,
        payload: {
          newPassword
        }
      })
    }
    catch (e) {
      dispatch({
        type: UPDATE_RESET,
        payload: {
          hasError: true,
          error: e.message
        }
      })
    }
  }
}

export const reportRepeatPassword = repeatPassword => {
  return async dispatch => {
    try {
      dispatch({
        type: UPDATE_RESET,
        payload: {
          repeatPassword
        }
      })
    }
    catch (e) {
      dispatch({
        type: UPDATE_RESET,
        payload: {
          hasError: true,
          error: e.message
        }
      })
    }
  }
}

export const reportVerificationCode = code => {
  return async dispatch => {
    try {
      dispatch({
        type: UPDATE_RESET,
        payload: {
          verificationCode: code
        }
      })
    }
    catch (e) {
      dispatch({
        type: UPDATE_RESET,
        payload: {
          hasError: true,
          error: e.message
        }
      })
    }
  }
}

export const requestCloseOfResetPassword = () => {
  return async dispatch => {
    try {
      dispatch({
        type: UPDATE_RESET,
        payload: {
          loading: false,
          success: false,
          show: false,
          newPassword: '',
          repeatPassword: '',
          verificationCode: '',
          hasError: false,
          error: ''
        }
      })
    }
    catch (e) {
      dispatch({
        type: UPDATE_RESET,
        payload: {
          hasError: true,
          error: e.message
        }
      })
    }
  }
}

export const requestPasswordReset = () => {
  return async(dispatch, getState) => {
    try {
      dispatch({
        type: UPDATE_RESET,
        payload: {
          loading: true,
          success: false,
          hasError: false,
          error: ''
        }
      })

      const {
        user,
        username
      } = getState().stores.auth

      const {
        newPassword,
        repeatPassword,
        verificationCode,
        resetWithCode
      } = getState().stores.auth.passwordReset

      let isValid = true

      if (newPassword !== repeatPassword) {
        isValid = false

        dispatch({
          type: UPDATE_RESET,
          payload: {
            loading: false,
            hasError: true,
            error: 'Passwords don\'t match'
          }
        })
      }

      if (!username) {
        isValid = false

        dispatch({
          type: UPDATE_RESET,
          payload: {
            loading: false,
            hasError: true,
            error: 'Username is blank'
          }
        })
      }

      if (resetWithCode) {
        if (!verificationCode) {
          isValid = false

          dispatch({
            type: UPDATE_RESET,
            payload: {
              hasError: true,
              error: 'Verification Code is blank',
              loading: false
            }
          })
        }
      }

      if (resetWithCode) {
        if (isValid) {
          await passwordResetWithCode(username, newPassword, verificationCode)

          dispatch({
            type: UPDATE_LOGIN,
            payload: {
              password: newPassword
            }
          })

          dispatch({
            type: UPDATE_RESET,
            payload: {
              show: false,
              success: true,
              loading: false,
              newPassword: '',
              repeatPassword: '',
              verificationCode: '',
              hasError: false,
              error: ''
            }
          })

          dispatch({
            type: UPDATE_VERIFICATION_CODE,
            payload: {
              success: false,
              loading: false,
              newPassword: '',
              repeatPassword: '',
              verificationCode: '',
              hasError: false,
              error: ''
            }
          })
        }
      }

      if (!resetWithCode) {
        if (isValid) {
          await passwordReset(user, newPassword)

          dispatch({
            type: UPDATE_LOGIN,
            payload: {
              password: newPassword
            }
          })

          dispatch({
            type: UPDATE_RESET,
            payload: {
              show: false,
              success: true,
              loading: false,
              newPassword: '',
              repeatPassword: '',
              verificationCode: '',
              hasError: false,
              error: ''
            }
          })
        }
      }
    }
    catch (e) {
      dispatch({
        type: UPDATE_RESET,
        payload: {
          loading: false,
          hasError: true,
          error: e.message
        }
      })
    }
  }
}

export const requestShowRequestForVerificationCode = () => {
  return async(dispatch, getState) => {
    dispatch({
      type: UPDATE_VERIFICATION_CODE,
      payload: {
        show: true
      }
    })
  }
}

export const requestCloseRequestForVerificationCode = () => {
  return async(dispatch, getState) => {
    dispatch({
      type: UPDATE_VERIFICATION_CODE,
      payload: {
        show: false,
        hasError: false,
        error: ''
      }
    })
  }
}

export const requestSendVerificationCode = () => {
  return async(dispatch, getState) => {
    try {
      dispatch({
        type: UPDATE_VERIFICATION_CODE,
        payload: {
          loading: true,
          hasError: false,
          error: ''
        }
      })

      const {
        username
      } = getState().stores.auth

      let isValid = true

      if (!username) {
        isValid = false

        dispatch({
          type: UPDATE_VERIFICATION_CODE,
          payload: {
            loading: false,
            hasError: true,
            error: 'Username is blank'
          }
        })
      }

      if (isValid) {
        await sendCode(username)

        dispatch({
          type: UPDATE_VERIFICATION_CODE,
          payload: {
            show: false,
            success: true,
            loading: false,
            hasError: false,
            error: ''
          }
        })

        dispatch({
          type: UPDATE_RESET,
          payload: {
            show: true,
            success: true,
            resetWithCode: true,
            loading: false,
            hasError: false,
            error: ''
          }
        })
      }
    }
    catch (e) {
      dispatch({
        type: UPDATE_VERIFICATION_CODE,
        payload: {
          loading: false,
          hasError: true,
          error: e.message
        }
      })
    }
  }
}

export const requestShowPasswordResetWithCode = () => {
  return async(dispatch, getState) => {
    dispatch({
      type: UPDATE_RESET,
      payload: {
        show: true,
        resetWithCode: true
      }
    })
  }
}

export const requestSignOut = () => {
  return (dispatch, getState) => {
    signOutUser()

    dispatch({
      type: UPDATE_AUTHENTICATED,
      payload: false
    })

    dispatch({
      type: UPDATE_USER,
      payload: {}
    })

    history.push('/login')
  }
}

export const requestNavigation = location => {
  return () => {
    history.push(location)
  }
}

export default handler